/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OrderTypeExpBulkUploadState {
    companyList: any[];
    selectedData: {
        code: any;
        select_type: any | null | undefined;
        select_add_type: any | null | undefined;
    };
    file: FileList | null;
    url: string;
    isDataValid: boolean;
}

const initialState: OrderTypeExpBulkUploadState = {
    companyList: [],
    selectedData: {
        code: null,
        select_type: { name: "Add Order Type Exception", select_type: "bulkOrderTypeException" },
        select_add_type: null,
    },
    file: null,
    url: "",
    isDataValid: false,
};

const orderTypeExpBulkUploadSlice = createSlice({
    name: "orderTypeExpBulkUpload",
    initialState,
    reducers: {
        setSelectedData(state, action: PayloadAction<any>) {
            const { key, value } = action.payload;
            state.selectedData = { ...state.selectedData, [key]: value };
        },
        setUploadedFile(state, action: PayloadAction<FileList | null>) {
            state.file = action.payload;
        },
        setCompanyList(state, action: PayloadAction<any[]>) {
            state.companyList = action.payload;
        },
        setUrl(state, action: PayloadAction<string>) {
            state.url = action.payload;
        },
        reset(state) {
            Object.assign(state, initialState);
        },
    },
});

export const orderTypeExpBulkUploadActions = orderTypeExpBulkUploadSlice.actions;
export { orderTypeExpBulkUploadSlice };
